export default "__VITE_ASSET__e14e50ec__"